/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Coach_Open_SourceInputs */

const en_us2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open study ${i?.n}`)
};

const pt_br2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir o estudo ${i?.n}`)
};

const es_419_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir el estudio ${i?.n}`)
};

const pt_pt2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir o estudo ${i?.n}`)
};

const fr_fr2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir l'étude ${i?.n}`)
};

const de_de2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Studie ${i?.n} öffnen`)
};

const it_it2_coach_open_source = /** @type {(inputs: Coach_Open_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apri lo studio ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Open study {n}" |
*
* @param {Coach_Open_SourceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_open_source = /** @type {((inputs: Coach_Open_SourceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Open_SourceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_open_source(inputs)
	if (locale === "es-419") return es_419_coach_open_source(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_open_source(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_open_source(inputs)
	if (locale === "de-DE") return de_de2_coach_open_source(inputs)
	if (locale === "it-IT") return it_it2_coach_open_source(inputs)
	return en_us2_coach_open_source(inputs)
});
export { coach_open_source as "coach.open_source" }